import React, { useCallback } from 'react';
import { GroupSearchResult } from 'graphql/types';
import { GroupSelectCount } from '../constant';
import { useGroupSelectLabel } from '../hooks/useGroupSelectType';
import { GroupSelect } from '../GroupSelect';
import { GroupSelectDropdownProp } from '../types';
import { useSelectSearchAction } from './hooks/useSelectSearchAction';

const emptyData: GroupSearchResult[] = [];

export const LocationsSelect: React.FC<GroupSelectDropdownProp> = ({
  groupType,
  rowID,
  defaultValues,
  classes
}: GroupSelectDropdownProp) => {
  const {
    searchHandler,
    data: { locations: locationsData },
    loading: { locations: locationsLoading }
  } = useGroupSelectLabel();

  const locations = locationsData?.groupsSearch?.locations.items || emptyData;
  const hasMore = locations.length === GroupSelectCount;
  const { handleSearch } = useSelectSearchAction(searchHandler);

  const onOpen = useCallback(() => {
    handleSearch(groupType, null);
  }, [groupType, handleSearch]);

  return (
    <GroupSelect
      groupType={groupType}
      onOpen={onOpen}
      handleSearch={handleSearch}
      options={locations}
      hasMore={hasMore}
      loading={locationsLoading}
      rowID={rowID}
      defaultValues={defaultValues}
      classes={classes}
    />
  );
};
